<script>
    /* Executable code section of the program */


    /* End of the section */
</script>
<!-- Section to place the HTML code -->
<section class="emptyContainer">
    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="bi bi-cloud-slash" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M3.112 5.112a3 3 0 0 0-.17.613C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13H11l-1-1H3.781C2.231 12 1 10.785 1 9.318c0-1.365 1.064-2.513 2.46-2.666l.446-.05v-.447q0-.113.018-.231zm2.55-1.45-.725-.725A5.5 5.5 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773a3.2 3.2 0 0 1-1.516 2.711l-.733-.733C14.498 11.378 15 10.626 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3c-.875 0-1.678.26-2.339.661z"/>
        <path d="m13.646 14.354-12-12 .708-.708 12 12z"/>
      </svg>
      <p>There are no nearby events registered</p>
</section>


<!-- End of the section -->
<style>
    /* Section to place the code styles */
    .emptyContainer{
        width: 90%;
        height: 20vh;
        padding: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    p{
        font-size: 20px;
    }
    

/* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    
}
/* /////////Cellphones ///////// */
@media (max-width: 700px) {

}


    /* End of the section */
</style>